import { normalizeSeoValues } from './normalizeSeoValues'

/**
 * Build Firestore `.update()` payload using dot paths under `seo.*`.
 * Only allowlisted fields are written; unknown sibling keys under `seo` stay intact.
 *
 * Does not mutate `seoInput`. Never includes name/url/order/id.
 *
 * @param {object} seoInput
 * @param {{ fields: string[], updated?: Date }} options — `fields` is required
 */
export function buildSeoDotPathUpdate(seoInput, { fields, updated = new Date() } = {}) {
  if (!Array.isArray(fields) || fields.length === 0) {
    throw new Error('buildSeoDotPathUpdate: fields allowlist is required')
  }

  const seo = normalizeSeoValues(seoInput, { fields })
  const payload = {}

  fields.forEach((field) => {
    if (field === 'updated') {
      payload['seo.updated'] = updated
      return
    }
    if (field === 'schemaVersion') {
      payload['seo.schemaVersion'] = 1
      return
    }
    payload[`seo.${field}`] = seo[field]
  })

  return payload
}
